// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"SecurityAcceptModal-modalContainer","modalSubheader":"SecurityAcceptModal-modalSubheader","agreementContainer":"SecurityAcceptModal-agreementContainer"};